import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import TripsDisplay from './TripsDisplay';
import HikeDisplay from './HikeDisplay';
import styles from '../css/aPanel.module.css';
import { AvalancheContext } from './context/AvalancheContext';

function AdminPanel({ isAdmin }) {
  const [trips, setTrips] = useState([]);
  const [hikes, setHikes] = useState([]);
  const [text, setText] = useState('');
  const { level, setLevel } = useContext(AvalancheContext);

  // Fetch Trips
  const fetchTrips = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin-api/all-trips`, { withCredentials: true });
      setTrips(response.data.data);
    } catch (err) {
      console.error('Error fetching Trips: ', err);
    }
  };

  // Fetch Hikes
  const fetchHikes = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin-api/all-hikes`, { withCredentials: true });
      setHikes(response.data.data);
    } catch (err) {
      console.error('Error fetching Hikes: ', err);
    }
  };

  // Fetch Avalanche Level
  const fetchAvalancheLevel = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin-api/avalanche-level`, { withCredentials: true });
      const { level: fetchedLevel } = res.data;

      if (fetchedLevel){
        setLevel(fetchedLevel);
      } else {
        setLevel('');
      }
    } catch (err) {
      console.error('Error fetching avalanche level:', err);
    }
  };

  useEffect(() => {
    if (isAdmin) {
      fetchTrips();
      fetchHikes();
      fetchAvalancheLevel();
    }
  }, [isAdmin]);

  const logOut = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin-api/logout`, {}, { withCredentials: true });
      if (res.data.success) {
        window.location.reload();
      } else {
        console.error('Logout failed');
      }
    } catch (err) {
      console.error('Error during logout', err);
    }
  };

  const handleChangeAvalanche = (e) => setText(e.target.value);

  const handleSubmitAvalanche = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/admin-api/avalanche-level`,
        { level: text },
        { withCredentials: true }
      );
      setLevel(text);
      setText('');
    } catch (err) {
      console.error('Error setting avalanche level:', err);
    }
  };

  return (
    <>
      <p>Panel Admina</p>
      <button className={styles.logOut} onClick={logOut}>Wyloguj</button>

      <div style={{ marginBottom: '6vh' }}>
        <form className={styles.formAdmin} onSubmit={handleSubmitAvalanche}>
          <label>Stopień zagrożenia lawinowego</label>
          <input type="text" value={text} onChange={handleChangeAvalanche} />
          <button>Zmień</button>
        </form>
        <p>⚠️ Stopień zagrożenia lawinowego w Tatrach: {level}</p>
      </div>

      <p>Przejazdy:</p>
      <TripsDisplay trips={trips} fetchTrips={fetchTrips} isAdmin={isAdmin} allViewTripsLength={trips.length} />
      <br />
      <hr />
      <br />
      <p>Wyprawy:</p>
      <HikeDisplay hikes={hikes} fetchHikes={fetchHikes} isAdmin={isAdmin} allViewHikesLength={hikes.length} />
    </>
  );
}

export default AdminPanel;
